// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 20px;
}

.order-item {
  width: 100%;
}
.order-item .img_section {
  min-height: 80px;
}
.order-item .img_section .img_wrap {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin: 0 auto;
  background: white;
}
.order-item .img_section .img_wrap:has(.default-img) {
  padding: 10px;
}
.order-item .img_section ion-img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.order-item .order-article-name {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: start;
  vertical-align: middle;
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.order-item .article-price {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  text-align: end;
  vertical-align: baseline;
  text-transform: uppercase;
  width: 100%;
  max-width: max-content;
  margin-left: auto;
}
.order-item .flex-text {
  margin-top: 5px;
  min-height: 20px;
}
.order-item .flex-text .option-name {
  font-size: 12px;
  color: #666;
  margin: 0;
}
.order-item .paddig-top {
  margin-top: 10px;
}
.order-item .article-name-col {
  padding-left: 0;
}
.order-item .quantity-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: 1px solid #262626;
  border-radius: 22px;
  height: 34px;
  width: 100px;
  padding: 0 5px;
}
.order-item .quantity-selector .quantity-btn {
  width: 25px;
  height: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.order-item .quantity-selector .quantity-btn ion-icon {
  font-size: 18px;
  color: #000;
  margin: 0;
}
.order-item .quantity-selector .quantity-btn:hover {
  opacity: 0.7;
}
.order-item .quantity-selector .quantity {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: #000;
  text-align: center;
}
.order-item .quantity-circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  border: 0.5px solid #262626;
  border-radius: 50px;
  margin-right: 10px;
  font-family: AppFont;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: baseline;
}
.order-item .edit_section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.order-item .edit_section ion-icon {
  font-size: 20px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;AADD;AAEC;EACC,mBAAA;AAAF;;AAIA;EACC,WAAA;AADD;AAGC;EACC,gBAAA;AADF;AAGE;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AADH;AAGG;EACC,aAAA;AADJ;AAIE;EACC,mBAAA;EACA,WAAA;EACA,YAAA;AAFH;AASC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AARF;AAWC;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;AATF;AAYC;EACC,eAAA;EACA,gBAAA;AAVF;AAYE;EACC,eAAA;EACA,WAAA;EACA,SAAA;AAVH;AAcC;EACC,gBAAA;AAZF;AAeC;EACC,eAAA;AAbF;AAiBC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAfF;AAiBE;EACC,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAfH;AAiBG;EACC,eAAA;EACA,WAAA;EACA,SAAA;AAfJ;AAkBG;EACC,YAAA;AAhBJ;AAoBE;EACC,oCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAlBH;AAsBC;EACC,oBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AAtBF;AA0BC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAxBF;AA0BE;EACC,eAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;AAzBH","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n.order-item {\n\twidth: 100%;\n\n\t.img_section {\n\t\tmin-height: 80px;\n\n\t\t.img_wrap {\n\t\t\twidth: 80px;\n\t\t\theight: 80px;\n\t\t\toverflow: hidden;\n\t\t\tmargin: 0 auto;\n\t\t\tbackground: white;\n\n\t\t\t&:has(.default-img) {\n\t\t\t\tpadding: 10px;\n\t\t\t}\n\t\t}\n\t\tion-img {\n\t\t\tobject-fit: contain;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\t// @include desktop {\n\t\t\t// \tobject-fit: contain;\n\t\t\t// }\n\t\t}\n\t}\n\n\t.order-article-name {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 18px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0.04em;\n\t\ttext-align: start;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t.article-price {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0;\n\t\ttext-align: end;\n\t\tvertical-align: baseline;\n\t\ttext-transform: uppercase;\n\t\twidth: 100%;\n\t\tmax-width: max-content;\n\t\tmargin-left: auto;\n\t}\n\n\t.flex-text {\n\t\tmargin-top: 5px;\n\t\tmin-height: 20px;\n\n\t\t.option-name {\n\t\t\tfont-size: 12px;\n\t\t\tcolor: #666;\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t.paddig-top {\n\t\tmargin-top: 10px;\n\t}\n\n\t.article-name-col {\n\t\tpadding-left: 0;\n\t}\n\n\t// Quantity Selector (Pill Shape: (-) 1 (+))\n\t.quantity-selector {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tbackground: transparent;\n\t\tborder: 1px solid #262626; // Dark border from design\n\t\tborder-radius: 22px;\n\t\theight: 34px;\n\t\twidth: 100px;\n\t\tpadding: 0 5px;\n\n\t\t.quantity-btn {\n\t\t\twidth: 25px;\n\t\t\theight: 100%;\n\t\t\tbackground: transparent;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tcursor: pointer;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: #000; // Black icons\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\topacity: 0.7;\n\t\t\t}\n\t\t}\n\n\t\t.quantity {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #000;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t.quantity-circle {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\theight: 24px;\n\t\twidth: 24px;\n\t\tborder: 0.5px solid #262626;\n\t\tborder-radius: 50px;\n\t\tmargin-right: 10px;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: baseline;\n\t}\n\n\t// Edit/Delete Actions\n\t.edit_section {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tgap: 8px;\n\n\t\tion-icon {\n\t\t\tfont-size: 20px;\n\n\t\t\tborder-radius: 50%;\n\t\t\twidth: 32px;\n\t\t\theight: 32px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
